import fetch from 'auth/FetchInterceptor';

const dateChangeService = {};

const api = 'booking-date-change-request';

dateChangeService.getAll = function (params) {
  return fetch({
    url: `${api}/getAll`,
    method: 'GET',
    params
  });
};



dateChangeService.get = function (id) {
  return fetch({
    url: `${api}/${id}`,
    method: 'GET'
  });
};

dateChangeService.post = function (data) {
  return fetch({
    url: `${api}`,
    method: 'POST',
    data: data
  });
};

dateChangeService.put = function (id, data) {
  return fetch({
    url: `${api}/status/${id}`,
    method: 'PUT',
    data: data
  });
};
dateChangeService.changeAdditionalDate = function (data) {
  return fetch({
    url: `${api}/additionalDate`,
    method: 'POST',
    data: data
  });
};

export default dateChangeService;
